import React, { Component } from 'react';
import { connect } from 'react-redux';

import { actions } from '../actions/user';

class AddUser extends Component {
  addUserHandler = () => {
    const { addUser } = this.props;
    addUser(this.input.value);
    this.input.value = '';
  }

  keyHandler = evt => {
    if (evt.which === 13) {
      this.addUserHandler();
    }
  }

  render() {
    return (
      <div className="panel">
        <div className="panel-title user-details">
          <div className="user-username">Add Member</div>
        </div>
        <div className="panel-content">
          <div className="row align-bottom">
            <div className="columns small-9">
              <label>Name</label>
              <input type="text" placeholder="RuneScape Name" ref={input => this.input = input} onKeyUp={this.keyHandler} />
            </div>
            <div className="columns small-3">
              <button className="button expanded primary" onClick={this.addUserHandler}>Add User</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  actions
)(AddUser);

// <div className="row push-bottom align-center">
//   <div className="columns small-12 shrink">
//     <label>&nbsp;</label>
//     <a className="button primary" ng-click="Dashboard.toggleMember()">Add Member</a>
//   </div>
//   <div className="columns small-12 medium-3 text-center" ng-if="Dashboard.haveUsers">
//     <label for="shareUrl"><strong>Share URL</strong></label>
//     <input focus-click id="shareUrl" type="text" ng-model="Dashboard.shareUrl" readonly>
//   </div>
//   <div className="columns small-12 shrink" ng-if="Dashboard.haveUsers">
//     <label>&nbsp;</label>
//     <button className="button accent" ng-click="Dashboard.saveSetup()">Save Roster</button>
//   </div>
//   <div className="columns small-12 shrink" ng-if="Dashboard.haveUsers">
//     <label>&nbsp;</label>
//     <button className="button alert">Reset Roster</button>
//   </div>
// </div>



// WEBPACK FOOTER //
// ./src/components/AddUser.js